import { packsForRec } from "./packs";

// Owner's dosing sequence: Alk -> pH -> Sanitiser/Shock -> Stabiliser -> Phos/Stain -> Salt -> Calcium -> Maintenance
const PRIORITY = { alk_up: 1, acid: 2, ph_up: 2, sanitiser: 3, oxidiser: 3, cl_down: 3, stab: 4, phos: 5, metal: 5, metal_stain: 5, general_stain: 5, scale: 5, salt: 6, cal_up: 7, floc: 9 };
export const priorityOf = (s) => (s.action && PRIORITY[s.action]) || 8;

export function stepFromRec(rec, matrix, catByName) {
  const pk = matrix ? packsForRec(rec, matrix) : null;
  const packs = pk && pk.lines.length ? pk.lines : null;
  const cp = catByName[(rec.product || "").toLowerCase()];
  const price = packs ? packs.reduce((s, l) => s + l.total, 0) : cp ? Number(cp.price || 0) : null;
  return {
    id: `auto-${rec.action}`, action: rec.action, key: rec.key, include: true, base: rec.title,
    title: rec.title, text: rec.text, product: packs ? packs.map((l) => `${l.qty} × ${l.name}`).join(" + ") : rec.product || "",
    sku_product: rec.product || "", price, amount: rec.amount, unit: rec.unit,
    lines: packs ? packs.map((l) => ({ name: l.name, qty: l.qty, part_id: l.part_id, price: l.price })) : null,
  };
}

// Keep staff edits/order/custom steps; refresh auto steps whose underlying recommendation changed.
export function mergeSteps(prev, recs, build) {
  const byAct = new Map(recs.map((r) => [r.action, r]));
  const out = prev.filter((s) => s.custom || byAct.has(s.action)).map((s) => {
    if (s.custom) return s;
    const r = byAct.get(s.action);
    return s.base === r.title ? s : { ...build(r), include: s.include };
  });
  recs.forEach((r) => {
    if (out.some((s) => s.action === r.action)) return;
    const st = build(r);
    const at = out.findIndex((s) => priorityOf(s) > priorityOf(st));
    if (at < 0) out.push(st); else out.splice(at, 0, st);
  });
  return out;
}

export const newCustomStep = () => ({ id: `custom-${Date.now()}`, custom: true, include: true, title: "", text: "", product: "", price: null });
